import { IMockProps, ErrorResponseCodeType } from '_core/types';
import MocksDef from './MocksDef';

import {
  CODE_ERRORS,
  ENDPOINT_API_PATH,
} from '../Definitions/ValidateDocumentDef';

type RequestSuccessType = {
  documentType?: 'CPF' | 'RNE' | 'PASSPORT';
  documentValue?: string;
  responseSuccess: {
    message?: string;
    memberNumber?: string;
    partner?: string;
    status?: string;
    smilesToken?: string;
  };
};

const SUCCESS_DOCUMENTS: RequestSuccessType[] = [
  {
    documentType: 'RNE',
    documentValue: MocksDef.DOCUMENT_TYPE.RNE,
    responseSuccess: {
      smilesToken: MocksDef.SMILES_TOKEN,
    },
  },
  {
    documentType: 'PASSPORT',
    documentValue: MocksDef.DOCUMENT_TYPE.PASSPORT,
    responseSuccess: {
      smilesToken: MocksDef.SMILES_TOKEN,
    },
  },
  {
    documentType: 'CPF',
    documentValue: MocksDef.DOCUMENT_TYPE.CPF,
    responseSuccess: {
      smilesToken: MocksDef.SMILES_TOKEN,
    },
  },
  {
    documentType: 'CPF',
    documentValue: '84362778560',
    responseSuccess: {
      message: 'XXXXX Não sei o que vamos devolver aqui',
      memberNumber: '123456780',
      partner: 'G3',
      status: 'INCOMPL. REGISTRATION PARTNER',
      smilesToken: MocksDef.SMILES_TOKEN,
    },
  },
  {
    documentType: 'CPF',
    documentValue: '07565850829',
    responseSuccess: {
      message: 'XXXXX Não sei o que vamos devolver aqui',
      memberNumber: '123456781',
      partner: 'SHE',
      status: 'INCOMPL. REGISTRATION PARTNER',
      smilesToken: MocksDef.SMILES_TOKEN,
    },
  },
  {
    documentType: 'CPF',
    documentValue: '10865073201',
    responseSuccess: {
      message: 'XXXXX Não sei o que vamos devolver aqui',
      memberNumber: '123456782',
      partner: 'CBB',
      status: 'ACTIVE',
      smilesToken: MocksDef.SMILES_TOKEN,
    },
  },
  {
    documentType: 'CPF',
    documentValue: '79451658009',
    responseSuccess: {
      message: 'XXXXX Não sei o que vamos devolver aqui',
      memberNumber: '123456783',
      partner: 'NBK',
      status: 'PRE REGISTRATION BANKS',
      smilesToken: MocksDef.SMILES_TOKEN,
    },
  },
  {
    documentType: 'CPF',
    documentValue: '50905691008',
    responseSuccess: {
      message: 'XXXXX Não sei o que vamos devolver aqui',
      memberNumber: '123456783',
      partner: 'NBK',
      status: 'INCOMPL. REGISTRATION PARTNER',
      smilesToken: MocksDef.SMILES_TOKEN,
    },
  },
];

const autoGenerateSuccess = (requestDocument: RequestSuccessType) => {
  const validateDocumentSuccess: IMockProps = {
    doc: {
      code: 'Validação com Sucesso',
      message: 'Validação com Sucesso',
    },
    configRequest: {
      method: 'POST',
      path: ENDPOINT_API_PATH,
      body: {
        type: requestDocument.documentType,
        value: requestDocument.documentValue,
      },
    },
    configResponse: {
      status: 200,
      data: requestDocument?.responseSuccess,
      headers: {},
    },
  };
  return validateDocumentSuccess;
};

const generatedSuccessMocks = SUCCESS_DOCUMENTS.map((requestDocument) =>
  autoGenerateSuccess(requestDocument),
);

const autoGenerate = (type: string, value: string | string[]) => {
  const listOfErrorsMock: IMockProps[] = CODE_ERRORS.map(
    (error: ErrorResponseCodeType, index: number) => {
      const body = {
        type,
        value: type !== 'CPF' ? `${value.slice(0, -1)}${index}` : value[index],
      };
      const formatedError: IMockProps = {
        doc: {
          code: error.code,
          message: error.message,
        },
        configRequest: {
          method: 'POST',
          path: ENDPOINT_API_PATH,
          body,
        },
        configResponse: {
          status: 452,
          data: {
            code: error.code,
            message: error.message,
            metadata: error.metadata,
          },
          headers: {},
        },
      };

      return formatedError;
    },
  );
  return listOfErrorsMock;
};
const autoGenerateErrorsMock = () => {
  const responseCPF = autoGenerate('CPF', MocksDef.CPF_ERRORS);
  const responseRNE = autoGenerate('RNE', MocksDef.DOCUMENT_TYPE.RNE);
  const responsePASSPORT = autoGenerate(
    'PASSPORT',
    MocksDef.DOCUMENT_TYPE.PASSPORT,
  );
  return [...responseCPF, ...responseRNE, ...responsePASSPORT];
};

const errorsGenerated = autoGenerateErrorsMock();

const ValidateDocumentMocks = [...generatedSuccessMocks, ...errorsGenerated];
export default ValidateDocumentMocks;
